let integratedApi = ""; //통합수강신청
let spacApi = ""; //SPAC
let spacWritingApi = ""; //SPAC-WRITING
let itmApi = ""; //ITM 수강신청정보
let ctmApi = ""; //CTM 수강신청정보
let channelUrl = ""; //전화영어 1:1문의
let itmUserInfoApi = ""; // ITM 학습정보 API
let ctmUserInfoApi = ""; // CTM 학습정보 API
let itmMyClass = ""; // ITM 나의 수업
let ctmMyClass = ""; //CTM 나의 수업
let carrotEnglishApi = ""; //carrotenglish api
let itmSugang = ""; //ITM 수강 사이트

if (location.origin.includes("local") || location.origin.includes("stage")) {
  integratedApi = "https://api-stage-integrated-sugang.carrotapply.com";
  spacApi = "http://www.thespac.net";
  spacWritingApi = "http://admin-writing.thespac.net";
  itmApi = "https://stage-itmsugang-api.carrotenglish.net";
  ctmApi = "https://applystage.carrotenglish.net";
  channelUrl = "https://yq8v6.channel.io";
  itmUserInfoApi = "https://stageitm.carrotenglish.net";
  itmMyClass = "http://stagest.carrotenglish.net"; //
  ctmMyClass = "https://carrotenglish.kr";
  ctmUserInfoApi = "https://stagectm.carrotenglish.kr";
  carrotEnglishApi = "https://carrotenglish.kr";
  itmSugang = "https://stage-itmsugang.carrotenglish.net";
} else {
  integratedApi = "https://api-integrated-sugang.carrotapply.com";
  spacApi = "http://www.thespac.net";
  spacWritingApi = "http://admin-writing.thespac.net";
  itmApi = "https://apply-api.carrotglobal.com";
  ctmApi = "https://apply2.carrotenglish.net";
  channelUrl = "https://pp7lz.channel.io";
  itmUserInfoApi = "https://itm.carrotenglish.net";
  itmMyClass = "https://student.carrotenglish.net"; //
  ctmMyClass = "https://carrotenglish.kr";
  ctmUserInfoApi = "https://ctm.carrotenglish.kr";
  carrotEnglishApi = "https://carrotenglish.kr";
  itmSugang = "https://apply.carrotglobal.com";
}

export {
  integratedApi,
  spacApi,
  spacWritingApi,
  itmApi,
  ctmApi,
  channelUrl,
  itmUserInfoApi,
  itmMyClass,
  ctmMyClass,
  ctmUserInfoApi,
  carrotEnglishApi,
  itmSugang,
};
